// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

export const plansTranslationsFr = {
  'plans.compare.title': 'Choisissez votre plan',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.free.price': '$0 / mois',
  'plans.compare.foundation.price': '$15 / mois',
  'plans.compare.pro.price': '$19 / mois',
  'plans.compare.foundation.badge': '150 places limitées',
  'plans.compare.cta.foundation': 'Devenir Founder',
  'plans.compare.cta.pro': 'Passer à PRO',
  'plans.compare.active': 'Plan actuel',
  'plans.compare.limited': '',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.limit.title.messages': 'Limite de messages atteinte',
  'plans.limit.message.messages': 'Limite de messages atteinte. Passez à FOUNDATION ou PRO.',
  'plans.limit.title.storage': 'Limite de stockage',
  'plans.limit.message.storage': 'Limite de stockage atteinte. Améliorez votre plan.',
  'plans.limit.title.invitations': 'Limite d\'invitations',
  'plans.limit.message.invitations': 'Limite d\'invitations atteinte. Améliorez votre plan.',
  'plans.founder.remaining': 'Il reste {count} places Founder',
  'plans.founder.remaining_last': 'Dernières {count} places Founder',
  'plans.founder.remaining_limited': 'Places limitées : il reste {count}',
  'plans.founder.remaining_very_low': 'Il ne reste que {count} places Founder',
  'plans.founder.soldout': 'Founder épuisé',
  'plans.limit.reached': 'Limite atteinte — Améliorer le plan',
  'plans.compare.pro.adjustment_notice': 'Le prix peut être ajusté selon les conditions du service.',
  'plans.compare.institucional.price': 'Tarification sur mesure',
  'plans.compare.institucional.title': 'Titre',
  'plans.compare.yourPlan': 'Votre plan',
  'plans.modal.title': 'Mettre à niveau le plan',
  'plans.modal.comparison_title': 'Comparaison des plans',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.modal.free.line1': '30 000 caractères par mois et par compte.',
  'plans.modal.free.line2': 'Jusqu\'à 2 contacts par utilisateur.',
  'plans.modal.free.line3': 'Jusqu\'à 2 conversations actives par compte.',
  'plans.modal.free.line4': 'Pas de pièces jointes ni d\'espace de stockage.',
  'plans.modal.free.line5': 'Pas d\'exportation de données.',
  'plans.modal.free.line6': 'Historique des messages jusqu\'à 30 jours.',
  'plans.modal.free.line7': '1 seul appareil par utilisateur.',
  'plans.modal.premium.line1': '300 000 caractères par mois et par compte.',
  'plans.modal.premium.line2': 'Jusqu\'à 100 contacts par utilisateur.',
  'plans.modal.premium.line3': 'Conversations et chats illimités (tenant).',
  'plans.modal.premium.line4': 'Jusqu\'à 50 Mo de stockage (tenant).',
  'plans.modal.premium.line5': 'Jusqu\'à 3 appareils par utilisateur.',
  'plans.modal.premium.line6': 'Invitations illimitées (tenant).',
  'plans.modal.premium.line7': 'Inclut export, traduction automatique et fichiers selon les limites du plan.',
  'plans.modal.premium_block_heading': 'Limites d\'usage du moteur (premium)',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'Programme Founder',
  'plans.modal.foundation.categories_title': 'Catégories Founder ({slots} places)',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': 'Position 1–25',
  'plans.modal.foundation.cat_legendary_desc': 'Les premiers à soutenir le projet. Priorité historique maximale.',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': 'Position 26–75',
  'plans.modal.foundation.cat_early_desc': 'Soutien précoce avec reconnaissance spéciale.',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': 'Position 76–150',
  'plans.modal.foundation.cat_std_desc': 'Place Founder parmi les 150.',
  'plans.modal.foundation.advantages_title': 'Avantages Founder',
  'plans.modal.foundation.adv1': 'Accès au pool Founder limité ({slots} places numérotées).',
  'plans.modal.foundation.adv2': 'Reconnaissance en tant qu\'utilisateur fondateur ArChat.',
  'plans.modal.foundation.adv3': 'Badge et présence Founder dans l\'expérience produit.',
  'plans.modal.foundation.adv4': 'Priorité historique et statut selon votre position (1–150).',
  'plans.modal.foundation.adv5': 'Avantage durable lié à votre accès Founder tant que la politique en vigueur s\'applique.',
  'plans.modal.pro.tagline': 'Premium standard — sans programme Founder',
  'plans.badges.foundation': 'Founder',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': 'Plan gratuit',
  'plans.free.price': '$0 / mois',
  'plans.free.features.contacts': 'Jusqu\'à 2 contacts par utilisateur',
  'plans.free.features.conversations': 'Jusqu\'à 2 conversations actives par compte',
  'plans.free.features.no_export': '30 000 caractères/mois par compte; 34 messages/jour et 1 000/mois; pas d\'export',
  'plans.free.features.no_advanced': 'Pas de fichiers ni stockage; historique 30 jours; 1 appareil par utilisateur',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'Plan Founder',
  'plans.foundation.price': '$15 / mois',
  'plans.foundation.features.contacts': 'Même contrat premium que PRO (jusqu\'à 100 contacts par utilisateur)',
  'plans.foundation.features.conversations': 'Conversations et chats illimités (tenant); mêmes limites que PRO',
  'plans.foundation.features.badge': 'Programme Founder (150 places numérotées)',
  'plans.foundation.features.support': 'USD 15/mois tant qu\'il reste des places Founder',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'Plan Pro',
  'plans.pro.price': '$19 / mois',
  'plans.pro.features.contacts': 'Jusqu\'à 100 contacts par utilisateur',
  'plans.pro.features.conversations': 'Conversations et chats illimités (tenant); 1 667 msg/jour, 50k/mois',
  'plans.pro.features.export': 'Jusqu\'à 50 Mo (tenant); export, traduction automatique et fichiers selon le plan',
  'plans.pro.features.notifications': 'Jusqu\'à 3 appareils par utilisateur; invitations illimitées (tenant)',
  'plans.actions.free': 'Plan actuel',
  'plans.actions.foundation': 'Devenir Fondateur',
  'plans.actions.pro': 'Passer à PRO',
  'plans.badges.recommended': 'RECOMMANDÉ',
  'plans.badges.limited': 'LIMITÉ',
  'plans.payments_disabled.title': 'Abonnements',
  'plans.payments_disabled.message': 'Les abonnements sont activés progressivement. Vous pouvez consulter les plans disponibles et leurs avantages.',
  'plans.payments_disabled.confirm': 'OK',
};